// extracted by mini-css-extract-plugin
export default {"container":"RWDtgl","flag-container":"Q1l_T_","flagContainer":"Q1l_T_","placeholder":"cIQbX9"};